import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import { IProduct } from '@src/quince-site-common/src/domains/Product/Product'

import useDeviceInfo, { DEVICE_TYPES } from '../../../../../quince-site-common/src/hooks/useDeviceInfo'
import { getFormattedAverageRating } from '../../../../../quince-site-common/src/utils/getFormattedAverageRating'
import { TrackConfig } from '../../../hocs/withTracking'
import { Button, ButtonProps } from '../../button'
import { FillRangeItemProps } from '../fillRangeItem'
import RangleSlider from '../productReviewSummaryRangeSliders'
import ReviewStars from '../reviewStars'

import styles from './productReviewSummary.module.scss'

export interface ProductReviewSummaryProps {
  ranges: FillRangeItemProps[]
  trackConfig?: TrackConfig
  reviewsCount: number
  avgRating: number
  writeReviewButton: ButtonProps
  className?: string
  product?: IProduct
  hideWriteReviewButton?: boolean
  openCreateReviewPopUp: () => void
  newPdpv2?: boolean
  isReviewSystemV3Enabled: boolean
}

export const ProductReviewSummary = ({ className = '', ...props }: ProductReviewSummaryProps) => {
  const { t } = useTranslation('common')
  const wrapClasses = classnames(styles.productReviewSummaryWrap, className)
  const ratingTitleClasses = classnames(styles.ratingTitle, 'font-family--ivy-headline')
  const reviewsCountClass = classnames(styles.reviewCount)

  const deviceInfo = useDeviceInfo()
  const isMobile = deviceInfo.deviceType !== DEVICE_TYPES.DESKTOP

  const isReviewSummaryRangeVisible = props.ranges.length > 0
  return (
    <div className={wrapClasses}>
      <div
        className={classnames(
          styles.reviewWrap,
          !isReviewSummaryRangeVisible ? styles.reviewWrap__withoutRange : '',
          props.newPdpv2 && styles.reviewWrap_newPdpv2,
        )}
      >
        <ReviewStars totalStars={5} fillStars={props.avgRating} />
        <div className={ratingTitleClasses}>
          {getFormattedAverageRating(props.avgRating)} {t('rating')}
        </div>
        <div data-testid={TEST_LOCATORS.REVIEW_SECTION_REVIEW_COUNT} className={reviewsCountClass}>
          {props.reviewsCount} {props.reviewsCount == 1 ? t('review') : t('reviews')}
        </div>
        {isMobile && isReviewSummaryRangeVisible && <RangleSlider newPdpv2={props.newPdpv2} ranges={props.ranges} />}
        {!props.hideWriteReviewButton && (
          <Button
            {...props.writeReviewButton}
            trackConfig={props.trackConfig}
            onClick={props.openCreateReviewPopUp}
            className={`${styles.reviewButton} padding-h--7 margin-top--3 ${!props.isReviewSystemV3Enabled ? 'margin-bottom--3' : ''}`}
            id={TEST_LOCATORS.REVIEW_SECTION_WRITE_REVIEW_BUTTON}
          />
        )}
      </div>
      {!isMobile && isReviewSummaryRangeVisible && <RangleSlider newPdpv2={props.newPdpv2} ranges={props.ranges} />}
    </div>
  )
}

export default ProductReviewSummary
